import { HttpInterceptorFn, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { TelegramService } from '../services/telegram-service/telegram.service';
import { environment } from '../../environments/environment';
import { valueIsNullOrEmpty } from '../helper/valueIsNullOrEmpty';
import { ApiErrorCode } from '../enums/api-error-code.enum';

// Токен для пометки "тихих" запросов, которые не должны показывать алерты
export const SILENT_REQUEST = new HttpContextToken<boolean>(() => false);

/**
 * HTTP интерсептор для добавления Telegram аутентификации в заголовки запросов
 * Добавляет заголовок Authorization: tma <token> ко всем исходящим HTTP запросам
 * При получении 401 ошибки перенаправляет на страницу выбора языка для регистрации
 */
export const telegramAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const telegramService = inject(TelegramService);
  const router = inject(Router);
  
  // Проверяем, является ли запрос "тихим" (без показа алертов)
  const isSilentRequest = req.context.get(SILENT_REQUEST);
  
  // Получаем токен аутентификации из Telegram Web App
  var authToken = telegramService.getAuthToken();
  console.log('authToken', authToken);
  if(!valueIsNullOrEmpty(environment.telegramAuthToken)) {
    authToken = environment.telegramAuthToken;
  }
  // Создаем запрос с токеном или без него
  const authReq = authToken 
    ? req.clone({
        headers: req.headers.set('Authorization', `tma ${authToken}`)
      })
    : req;
  
  // Выполняем запрос и обрабатываем ошибки
  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Логируем все ошибки для отладки
      console.error('HTTP Error:', error.status, error.message, error.url);
      
      // Для "тихих" запросов не показываем алерты
      if (isSilentRequest) {
        return throwError(() => error);
      }
      
      // Формируем сообщение об ошибке
      const errorMessage = error.error?.message || error.error?.errorCode || error.message || 'Unknown error';
      
      // Если получили 401 ошибку (Unauthorized), перенаправляем на регистрацию
      // Но только если пользователь НЕ на странице регистрации (защита от бесконечного цикла)
      if (error.status === 401) {
        const currentUrl = router.url;
        if (!currentUrl.startsWith('/registration')) {
          router.navigate(['/registration/choose-country']);
        }
      }
      
      // 403 - недостаточно прав, перенаправляем на регистрацию
      if (error.status === 403 && error.error?.errorCode === ApiErrorCode.Forbidden) {
        const currentUrl = router.url;
        if (!currentUrl.startsWith('/registration')) {
          router.navigate(['/registration/choose-country']);
        }
      }
      
      // 500 - серверная ошибка
      if (error.status === 500) {
        // TODO: Временно отключены алерты - включить при необходимости отладки
        // alert(`Серверная ошибка (500): ${errorMessage}\nURL: ${error.url}`);
      }
      
      // 0 - нет соединения с сервером
      if (error.status === 0) {
        // TODO: Временно отключены алерты - включить при необходимости отладки
        // alert(`Ошибка сети: Не удалось подключиться к серверу\nURL: ${error.url}`);
      }
      
      // Другие ошибки (400, 404, и т.д.)
      if (error.status !== 401 && error.status !== 403 && error.status !== 500 && error.status !== 0) {
        // TODO: Временно отключены алерты - включить при необходимости отладки
        // alert(`HTTP ошибка (${error.status}): ${errorMessage}\nURL: ${error.url}`);
      }
      
      // Пробрасываем ошибку дальше для обработки в компонентах
      return throwError(() => error);
    })
  );
};
